import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { ListServerPaginationStateModel, LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { ClosedPeriodListState } from './closed-period-list.state';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../list-search-criteria';
import { take } from 'rxjs/operators';
import { DockItemFacade } from '../../../dock/item/dock-item.facade';
import { CompartmentItemFacade } from '../../../compartment/item/compartment-item.facade';
import { ClosedPeriodListSearchCriteria, ClosedPeriodModel } from '../models';
import { ClosedPeriodListInitialState, ClosedPeriodListLoad } from './closed-period-list.actions';

@Injectable({ providedIn: 'root' })
export class ClosedPeriodListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<ListServerPaginationStateModel<ClosedPeriodModel>> = this.store.select(
    ClosedPeriodListState.getClosedPeriods,
  );
  loaded$: Observable<boolean> = this.store.select(ClosedPeriodListState.getLoaded);
  timezone$: Observable<string> = this.store.select(ClosedPeriodListState.getTimezone);

  constructor(
    private store: Store,
    private compartmentItemFacade: CompartmentItemFacade,
    private dockItemFacade: DockItemFacade,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
  ) {}

  loadAll(): void {
    combineLatest([
      this.compartmentItemFacade.compartmentId$,
      this.dockItemFacade.dockId$,
      this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.ClosedPeriods),
    ])
      .pipe(take(1))
      .subscribe(([compartmentId, dockId, searchCriteria]: [number, number, ClosedPeriodListSearchCriteria]) => {
        this.store.dispatch(
          new ClosedPeriodListLoad({
            compartmentId,
            dockId,
            searchCriteria,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new ClosedPeriodListInitialState());
  }
}
